import { ApplicationNames, StorageValues, ToastMessage, ToastShowDelay } from '../core/consts';
import { AuthenticationService } from '../core/services/auth.service';
import { AutoLogoutService } from '../core/services/utelize/general/auto-logout-service';
import { BrowserInfoService } from '../core/services/utelize/general/browser-info-service';
import { ClientInfoService } from '../core/services/utelize/general/client-info-service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { DecryptAesClientSide } from '../core/encryption';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from '../core/services/utelize/general/exceptions-service';
import { PageViewTrackerService } from '../core/services/utelize/general/page-view-tracker-service';
import { RootReducerState } from '../store';
import { StorageService } from '../core/services/utelize/general/storage-service';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { ToastService } from '../core/services/toast-service';
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})

export class LayoutComponent implements OnDestroy, OnInit {

  private applicationName: string=environment.platformModeInview ? ApplicationNames.InviewPortal : ApplicationNames.eSimPlatform;
  private layoutSub!     : Subscription;
  private layoutType!    : string;

  constructor(
    private authenticationService: AuthenticationService,
    private autoLogoutService    : AutoLogoutService,
    private browserInfoService   : BrowserInfoService,
    private clientInfoService    : ClientInfoService,
    private exceptionsService    : ExceptionsService,
    private pageViewTracker      : PageViewTrackerService,
    private storageService       : StorageService,
    private store                : Store<RootReducerState>,
    private toastService         : ToastService
  ) { }

  public ngOnInit(): void {
    try {
      this.autoLogoutService.start();

      this.removeToasts();
      this.browserInfoService.sendBrowserInfo(true);
      this.clientInfoService.sendClientInfo();
      this.pageViewTracker.start();
      this.showWelcomeToast();

      this.layoutSub=this.store.select('layout').subscribe((data) => {
        this.layoutType=data.LAYOUT;
        document.documentElement.setAttribute('data-layout',          data.LAYOUT);
        document.documentElement.setAttribute('data-bs-theme',        data.LAYOUT_MODE);
        document.documentElement.setAttribute('data-layout-width',    data.LAYOUT_WIDTH);
        document.documentElement.setAttribute('data-layout-position', data.LAYOUT_POSITION);
        document.documentElement.setAttribute('data-topbar',          data.TOPBAR);

        data.LAYOUT == "vertical" || data.LAYOUT == "twocolumn" ? document.documentElement.setAttribute('data-sidebar',       data.SIDEBAR_COLOR) : '';
        data.LAYOUT == "vertical" || data.LAYOUT == "twocolumn" ? document.documentElement.setAttribute('data-sidebar-size',  data.SIDEBAR_SIZE)  : '';
        data.LAYOUT == "vertical" || data.LAYOUT == "twocolumn" ? document.documentElement.setAttribute('data-sidebar-image', data.SIDEBAR_IMAGE) : '';
        data.LAYOUT == "vertical" || data.LAYOUT == "twocolumn" ? document.documentElement.setAttribute('data-layout-style',  data.SIDEBAR_VIEW)  : '';

        document.documentElement.setAttribute('data-preloader',          data.DATA_PRELOADER)
        document.documentElement.setAttribute('data-sidebar-visibility', data.SIDEBAR_VISIBILITY);
      })
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy(): void {
    try {
      this.layoutSub?.unsubscribe();
      this.pageViewTracker.stop();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public isHorizontalLayoutRequested(): boolean {
    try {
      return this.layoutType === 'horizontal';
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }
  
  public isSemiboxLayoutRequested(): boolean {
    try {
      return this.layoutType === 'semibox';
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }
  
  public isTwoColumnLayoutRequested(): boolean {
    try {
      return this.layoutType === 'twocolumn';
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }
  
  public isVerticalLayoutRequested(): boolean {
    try {
      return this.layoutType === 'vertical';
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }
    
  public removeToasts() {
    try {
      this.toastService.removeAll();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public showWelcomeToast(): void {
    try {
      if (!DecryptAesClientSide(this.storageService.getItem(StorageValues.encInitialLogin)))
        return;

      this.storageService.removeItem(StorageValues.encInitialLogin);

      const firstname: string=this.authenticationService?.currentUserObject()?.firstname ?? "";

      this.toastService.show(`${ToastMessage.System_WelcomeToThe} ${this.applicationName} ${firstname}`.trim(),
                             { classname: 'bg-success text-white', delay: ToastShowDelay.Success });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
